import React from 'react';
import t from 'babel-plugin-yate/macro';

function Locations(props) {
  const { user, locationId, changeLocation } = props;

  return (
    <div className="relative max-w-xs">
      <select
        className="block appearance-none w-full text-black py-3 px-4 pr-8 rounded leading-tight focus:outline-none bg-white border border-white focus:border-white-light hover:border-white-light"
        value={locationId}
        onChange={(event) => changeLocation(event.target.value)}
        style={{ textAlignLast: "right" }}
      >
        <option value={0}>{t`All locations`}</option>

        {Object.keys(user.locations).map((locKey) => (
          <option
            key={user.locations[locKey].id}
            value={user.locations[locKey].id}
          >
            {user.locations[locKey].name}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-grey-darker-3">
        <svg
          className="fill-current inline h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>
    </div>
  )
}

export default Locations;
